import { linkStats } from './stats.js';

export const loadTeasersOnScroll = async (btn) => {
  if (!btn) { return; }
  const previousElement = btn.previousElementSibling;

  if (previousElement && previousElement.classList.contains('teaser')) {
    const dataLoadUrl = previousElement.getAttribute('data-load-url');

    if (dataLoadUrl) {
      try {
        const response = await fetch(dataLoadUrl);
        if (!response.ok) {
          throw new Error(`Server responded with status: ${response.status}`);
        }
        const html = await response.text();
        const temporaryContainer = document.createElement('div');
        temporaryContainer.innerHTML = html;

        btn.insertAdjacentHTML('beforebegin', html);

        const newTeasers = Array.from(document.querySelectorAll('.teaser:not([data-initialized])'));
        newTeasers.forEach((teaser) => teaser.setAttribute('data-initialized', 'true'));
        linkStats(newTeasers);

        if (!newTeasers.some((teaser) => teaser.getAttribute('data-load-url'))) {
          btn.style.display = 'none';
        }
      } catch (err) {
        console.log('Error', err);
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('error-message');
        errorMessage.innerText = 'Wystąpił błąd podczas ładowania treści. Proszę spróbować ponownie.';
        btn.insertAdjacentElement('beforebegin', errorMessage);

        setTimeout(() => {
          errorMessage.remove();
        }, 5000);
      }
    }
  }
};

export const loadTeasers = () => {
  document.querySelectorAll('.teaser').forEach((teaser) => teaser.setAttribute('data-initialized', 'true'));
};
